import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';

import { Typography } from '@mui/material';
import Container from 'components/Container';
import Archive2022 from '../ClassAssembly2023/Archive2022';
import ClassAssemblySidebar2026 from '../ClassAssemblySidebar2026';

const ClassAssembly4E2026 = () => {
  const theme = useTheme();
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  const openLightbox = (index) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  };

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  const [config, setConfig] = useState({ base_image_url_2026: '' });
  useEffect(() => {
    fetch('/config.json')
      .then(response => response.json())
      .then(data => setConfig(data))
      .catch(error => console.error('Error fetching config:', error));
  }, []);

  const p1 = `${config.base_image_url_2026}/home/events-activities/class-assembly/4E/1.webp`;
  const p2 = `${config.base_image_url_2026}/home/events-activities/class-assembly/4E/2.webp`;
  const p3 = `${config.base_image_url_2026}/home/events-activities/class-assembly/4E/3.webp`;
  const p4 = `${config.base_image_url_2026}/home/events-activities/class-assembly/4E/4.webp`;
  const p5 = `${config.base_image_url_2026}/home/events-activities/class-assembly/4E/5.webp`;
  const p6 = `${config.base_image_url_2026}/home/events-activities/class-assembly/4E/6.webp`;
  const p7 = `${config.base_image_url_2026}/home/events-activities/class-assembly/4E/7.webp`;
  const p8 = `${config.base_image_url_2026}/home/events-activities/class-assembly/4E/8.webp`;



  const photos = [
    { src: p1, source: p1, rows: 1, cols: 1 },
    { src: p2, source: p2, rows: 1, cols: 1 },
    { src: p3, source: p3, rows: 1, cols: 1 },
    { src: p4, source: p4, rows: 1, cols: 1 },
    { src: p5, source: p5, rows: 1, cols: 1 },
    { src: p6, source: p6, rows: 1, cols: 1 },
    { src: p7, source: p7, rows: 1, cols: 1 },
    { src: p8, source: p8, rows: 1, cols: 1 },

  ];

  return (
    <Main>
      <Container>
        <Grid container spacing={4}>
          <Grid item xs={12} md={8}>
            <Box>
              <Box>
                <Typography variant="h4" align="center">
                  Topic: Freedom and Happiness
                </Typography>
                <Typography fontSize="x-small">
                  <br />
                  <br />
                  Class:- 4E      Date: 13 and 14 AUGUST 2026
                </Typography>

        <Typography variant={'subtitle1'} align={'justify'}>
“Freedom is not just a gift we receive; it is a responsibility we carry with pride, gratitude and love for our
nation.” 
<br></br>
   The enthusiastic students of Class 4E presented an inspiring assembly on the theme ‘Freedom and
Happiness’ on Thursday and Friday, 13 and 14 August 2026. The assembly began with a meaningful Thought
for the Day, followed by an engaging introduction and a speech highlighting the true meaning of freedom
and happiness.
        <br></br>
        The students then presented a vibrant dance performance celebrating the spirit of patriotism and the
significance of our National Flag. Through the colours of the Tricolour, they beautifully conveyed the values
of courage, peace, truth, growth and progress. The performance added energy and emotion to the assembly
while reminding everyone of the ideals that guide our nation.
  <br></br>
  The assembly concluded with a strong message on patriotism, gratitude and responsibility. The students
reminded the audience that true love for our country lies in working together, respecting one another and
contributing towards building a stronger, happier and better India. The assembly ended on a proud and
inspiring note, filling everyone with gratitude for the freedom we enjoy and love for our nation.
 <br></br>
        </Typography>
              </Box>

            <Typography
                variant="h6"
                 color="primary"
                 align="center"
                 fontWeight="normal">
                <br />
   The secret of happiness is freedom and the secret of freedom is courage
                 <br />
            </Typography>

              <Box>
                <ImageList
                  variant="quilted"
                  cols={2}
                  rowHeight={isMd ? 200 : 100}
                  gap={isMd ? 16 : 4}
                >
                  {photos.map((item, i) => (
                    <ImageListItem key={i} cols={item.cols} rows={item.rows}>
                      <LazyLoadImage
                        height={'100%'}
                        width={'100%'}
                        src={item.src}
                        alt="Class Assembly 4C 2026"
                        effect="blur"
                        onClick={() => openLightbox(i)}
                        style={{
                          objectFit: 'cover',
                          filter:
                            theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                          cursor: 'pointer',
                          borderRadius: 8,
                        }}
                      />
                    </ImageListItem>
                  ))}
                </ImageList>
              </Box>

              {viewerIsOpen && (
                <Lightbox
                  mainSrc={photos[currentImage].src}
                  nextSrc={photos[(currentImage + 1) % photos.length].src}
                  prevSrc={photos[(currentImage + photos.length - 1) % photos.length].src}
                  onCloseRequest={() => closeLightbox()}
                  onMovePrevRequest={() =>
                    setCurrentImage((currentImage + photos.length - 1) % photos.length)
                  }
                  onMoveNextRequest={() =>
                    setCurrentImage((currentImage + 1) % photos.length)
                  }
                  reactModalStyle={{ overlay: { zIndex: 1500 } }}
                />
              )}
            </Box>
          </Grid>

          <Grid item xs={12} md={4}>
            <Box marginBottom={4}>
              <ClassAssemblySidebar2026 />
            </Box>
            <Box marginBottom={4}>
              <Archive2022 />
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Main>
  );
};

export default ClassAssembly4E2026;
